"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
const react_1 = __importDefault(require("react"));
const useInheritedStyles_1 = require("../../../hooks/useInheritedStyles");
const getResponsiveStyle_1 = require("../../../utils/getResponsiveStyle");
const Box_1 = require("../../Box");
const TypographyVariants_1 = require("./TypographyVariants");
exports.Text = react_1.default.forwardRef((props, ref) => {
    const { className, children, as, weight, size, lineHeight, letterSpacing, variant, sx = {} } = props;
    const computedAs = react_1.default.useMemo(() => {
        switch (variant) {
            case "h1":
            case "h1-light":
                return "h1";
            case "h2":
            case "h2-light":
                return "h2";
            case "h3":
            case "h3-light":
                return "h3";
            case "h4":
            case "h4-light":
                return "h4";
            case "h5":
            case "h5-light":
                return "h5";
            case "h6":
            case "h6-light":
                return "h6";
            default:
                return "span";
        }
    }, [variant]);
    const { newInheritedStylesContext, mergedSx } = (0, useInheritedStyles_1.useMergeStyles)(sx);
    /*
      Inheritance (high -> low):
      - component style: custom styles applied directly through props or sx
      - variant style: pre-set styles applied through the variant
      - inherited style: styles inherited from parent node
      - default style: base styles set in context or by browser
    */
    const updatedStyleContext = react_1.default.useMemo(() => {
        const computedFontSize = size
            ? size
            : variant
                ? (0, getResponsiveStyle_1.getResponsiveStyle)(variant, (v) => TypographyVariants_1.TypographyVariants[v].fontSize)
                : newInheritedStylesContext.fontSize;
        const computedFontWeight = weight
            ? `font-weight-${weight}`
            : variant
                ? (0, getResponsiveStyle_1.getResponsiveStyle)(variant, (v) => TypographyVariants_1.TypographyVariants[v].fontWeight)
                : newInheritedStylesContext.fontWeight;
        const computedLineHeight = lineHeight
            ? lineHeight
            : variant
                ? (0, getResponsiveStyle_1.getResponsiveStyle)(variant, (v) => TypographyVariants_1.TypographyVariants[v].lineHeight)
                : newInheritedStylesContext.lineHeight;
        const computedLetterSpacing = letterSpacing
            ? letterSpacing
            : variant
                ? (0, getResponsiveStyle_1.getResponsiveStyle)(variant, (v) => TypographyVariants_1.TypographyVariants[v].letterSpacing)
                : newInheritedStylesContext.letterSpacing;
        return Object.assign(Object.assign({}, newInheritedStylesContext), { fontSize: computedFontSize || "font-size-4", fontWeight: computedFontWeight || "font-weight-regular", lineHeight: computedLineHeight || "leading-2", letterSpacing: computedLetterSpacing });
    }, [
        letterSpacing,
        lineHeight,
        newInheritedStylesContext,
        size,
        variant,
        weight
    ]);
    return (react_1.default.createElement(useInheritedStyles_1.InheritedStylesProvider, { styleContext: updatedStyleContext },
        react_1.default.createElement(Box_1.Box, { ref: ref, as: as || computedAs, className: className, sx: Object.assign(Object.assign(Object.assign({}, mergedSx), updatedStyleContext), { textTransform: variant === "overline" ? "uppercase" : "unset" }) }, children)));
});
exports.Text.displayName = "Text";
//# sourceMappingURL=Text.js.map